export default __webpack_public_path__ + "static/media/undraw_video_files_fu10.cbe9fd81.svg";